import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { useMutation, useQueryClient } from 'react-query';
import {
  ILandingPageDesignBase,
  ILandingPageDesignResponse,
  ILpCustomer,
  ILpReseller,
} from 'app/pages/admin/landing-pages-v2/types';

export interface IUpdateLandignPageDesignParams extends ILandingPageDesignBase {
  id: number;
  headerLogo: string;
  bodyBackgroundImage: string;
  customers: ILpCustomer[];
  resellers: ILpReseller[];
}

export const updateLandingPageDesign = async (
  params: IUpdateLandignPageDesignParams
) => {
  const response = await EXPRESS_API.put(
    `/superadmin/landing-page-designs/${params.id}`,
    params
  );
  return response.data as ILandingPageDesignResponse;
};

export const useEditLandingPageDesignMutation = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { showError } = useToastError();
  return useMutation(updateLandingPageDesign, {
    onSuccess: async () => {
      await queryClient.refetchQueries({
        queryKey: 'LANDING_PAGE_DESIGNS',
        exact: false,
      });
      await queryClient.refetchQueries({
        queryKey: 'LANDING_PAGE_DESIGN_GROUPS',
        exact: false,
      });
      onSuccess && onSuccess();
      successToast({ title: 'Template has been successfully updated!' });
    },
    onError: error =>
      showError(
        error || 'An error occured while trying to update the template!'
      ),
  });
};
